import { AppState } from '../../store/initialStateRegistration';
import {
  getAdSlots, getDfpProperty,
  getEdition, getExperiments,
  getHeaderBidderPublisherID,
  getLanguage,
  getPageType,
  getSiteName,
} from '../../store/config/config.selectors';
import { getCountryCode } from '../templates.utils';

export const getAnalyticsCoreParamsForAllPages = (state: AppState) => ({
  siteName: getSiteName(state),
  property: getEdition(state),
  language: getLanguage(state),
  pageType: getPageType(state),
  adSlots: getAdSlots(state),
  headerBidderPublisherID: getHeaderBidderPublisherID(state),
  countryCode: getCountryCode(),
  dfpProperty: getDfpProperty(state),
  experiments: getExperiments(state),
});
